import tinycolor from "tinycolor2";
import jssVariables from "../jss_setup";
import { getColors } from "../jss_setup/colors";

export const hotels = {
  hotelsList: {
    gridGap: jssVariables.double_gap,
    smallscreen: {
      padding: jssVariables.spacing.center_padding_medium,
    },
  },
};

export const hotelStyles = {
  hotel: {
    borderRadius: jssVariables.normal_gap,
    boxShadow: "1px 3px 9px rgba(0, 0, 0, 0.25)",
  },
  placeholderImg: {
    borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
  imgContainer: {
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    },
  },
  img: {
    borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
  imgOverlay: {
    borderRadius: `0 0 ${jssVariables.normal_gap} ${jssVariables.normal_gap} `,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
  contentAndBtmContr: {
    gridTemplateColumns: "1fr",
    smallscreen: {
      gridTemplateColumns: "1fr",
    },
  },
  content: {
    smallscreen: {
      gridColumn: "span 2",
    },
  },
  title: {
    fontSize: "x-large",
    smallscreen: {
      fontSize: "x-large",
    },
  },
  RatingPanel: {
    iconFilled: {
      color: "#fdb211",
    },
  },
};

export const hotelSearchStrip = {
  SearchStripDefault: {
    background: tinycolor(getColors().base_color).lighten(30).toHexString(),
  },
};

export const hotelFiltersBar = {
  FiltersBar: {
    background: tinycolor(getColors().base_color).lighten(34).toHexString(),
  },
};

export const hotelFilters = {
  Filters: {
    borderRadius: jssVariables.border_radius,
  },
};

export const hotelBottomContainer = {
  BottomContainer: {
    gridTemplateColumns: "max-content",
    justifyContent: "end",
    gridGap: jssVariables.half_gap,
    smallscreen: {
      justifyItems: "baseline",
      gridTemplateColumns: "max-content",
    },
  },
  placeholderParagraph: {
    width: "80vw",
    smallscreen: {
      width: "30rem",
    },
  },
  priceContainer: {
    fontSize: "medium",
  },
  priceTxt: {
    gridGap: jssVariables.half_gap,
    justifyContent: "unset",
  },
  Price: {
    color: jssVariables.colors.text.dark,
    fontSize: "xx-large",
  },
  divider: {
    smallscreen: {
      width: "100%",
      gridColumn: "span 2",
      height: "1px",
      background: jssVariables.colors.border,
      marginLeft: 0,
    },
  },
};

export const landingPageHotelStyles = {
  hotel: {
    borderRadius: jssVariables.normal_gap,
    boxShadow: "1px 3px 9px rgba(0, 0, 0, 0.25)",
  },
  imgContainer: {
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    },
  },
  img: {
    borderRadius: `${jssVariables.normal_gap} ${jssVariables.normal_gap} 0 0`,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
  imgOverlay: {
    borderRadius: `0 0 ${jssVariables.normal_gap} ${jssVariables.normal_gap} `,
    smallscreen: {
      borderRadius: `${jssVariables.normal_gap} 0 0 ${jssVariables.normal_gap}`,
    },
  },
};

export const hotelBottomContainerMobileView = {
  divider: {
    smallscreen: {
      display: "block",
      width: "100%",
      height: "1px",
      background: jssVariables.colors.border,
      marginLeft: 0,
    },
  },
};

export const productStyles = {
  btn: {
    background: jssVariables.colors.base_color,
  },
};

export const hotelDetails = {
  header: {},
  rate: {
    color: "#ffbe0f",
    fontSize: "xx-large",
  },
  address: {},
  descriptionHeader: {},
  descriptionText: {},
  btn: {},
  facilitiesHeader: {},
  tag: {},
};

export const hotelSearchDestination = {
  searchDestination: {
    textAlign: "left",
    smallscreen: {
      textAlign: "center",
    },
  },
};

export const hotelSearchDates = {
  searchDates: {
    fontWeight: "bold",
  },
  header: {
    display: "none",
  },
};

export const hotelSearchPax = {
  header: {
    display: "none",
  },
  body: {
    fontWeight: "bold",
  },
};

export const sliderLclHotelDetails = {
  sliderContainer: {
    background: jssVariables.colors.base_color,
  },
};

export const deepViewHotelCustomStyles = {
  imgContainer: {
    display: "none",
    smallscreen: {},
  },
  hotel: {
    gridTemplateRows: "max-content 1fr",
    width: "90vw",
    smallscreen: {
      width: "30vw",
    },
  },
};

export const hotelSearchForm = {
  searchForm: { borderRadius: jssVariables.normal_gap },
};

export const filtersBarFlights = {
  items: {
    color: jssVariables.colors.text.dark,
  },
  btn: {
    textTransform: "uppercase",
    color: "white",
    fontSize: "medium",
  },
};

export const paxModalCustomStyles = {
  ages: {
    background: tinycolor(jssVariables.colors.base_color)
      .lighten(30)
      .toRgbString(),
  },
  ageSelectField: {
    background: tinycolor(jssVariables.colors.base_color)
      .lighten(30)
      .toRgbString(),
  },
};

export const navbar = {
  item: {
    smallscreen: {
      fontSize: "large",
    },
  },
};
